type DashboardSectionDescription = {
  sectionTitle: string;
  tooltipLabel: string;
  histogramTitle: string;
};

export const overviewParameters: {
  [key: string]: DashboardSectionDescription;
} = {
  similarProducts: {
    sectionTitle: "similar products",
    tooltipLabel: "results",
    histogramTitle: "total successful results",
  },
  crossSelling: {
    sectionTitle: "Cross-Selling",
    tooltipLabel: "results",
    histogramTitle: "total successful results",
  },
  visualSearch: {
    sectionTitle: "visual search",
    tooltipLabel: "searches",
    histogramTitle: "total uploads / searches",
  },
  textSearch: {
    sectionTitle: "text search",
    tooltipLabel: "searches",
    histogramTitle: "total searches",
  },
  productData: {
    sectionTitle: "product data",
    tooltipLabel: "predictions",
    histogramTitle: "total predictions",
  },
};

export const availableSections = Object.keys(overviewParameters);
